module.exports = __webpack_public_path__ + "modules/teas/img/bootscreen-bjkc.png";